// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ukkD","left":"styles_left__3Drxp","right":"styles_right__1EPoj","alert":"styles_alert__2LWlX"};